function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.66667 0.95H4.61667V1V5.53333H1H0.95V5.58333V15.3333V15.3833H1H4.61667V23V23.05H4.66667H17.5H17.5207L17.5354 23.0354L23.0354 17.5354L23.05 17.5207V17.5V1V0.95H23H4.66667ZM19.5833 5.53333H5.63333V1.96667H22.0333V16.5333H16.5833H16.5333V16.5833V22.0333H5.63333V15.3833H19.5833H19.6333V15.3333V5.58333V5.53333H19.5833ZM1.96667 14.3667V6.55H18.6167V14.3667H1.96667ZM21.5831 17.55L17.55 21.5831V17.55H21.5831Z",
  fill: "#685DA8",
  stroke: "#685DA8",
  strokeWidth: 0.1
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 2,
  y: 6,
  width: 17,
  height: 9,
  fill: "#685DA8"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.3006 10.7589C17.3915 10.8908 17.4546 11.0345 17.4898 11.1943C17.525 11.3512 17.5426 11.5286 17.5426 11.7207C17.5426 12.3835 17.3505 12.8659 16.9663 13.1679C16.5822 13.4699 16.047 13.6224 15.3608 13.6224C14.6453 13.6224 14.1335 13.467 13.8242 13.1562C13.5162 12.8453 13.3638 12.3996 13.3638 11.819V11.5638H14.6306V11.75C14.6306 11.8967 14.6423 12.0301 14.6643 12.1489C14.6892 12.2691 14.7318 12.3703 14.7963 12.4524C14.8608 12.5359 14.9488 12.6005 15.0573 12.6474C15.1643 12.6928 15.3021 12.7178 15.4649 12.7178C15.6599 12.7178 15.8329 12.6547 15.9883 12.5286C16.1423 12.4025 16.2215 12.206 16.2215 11.9436C16.2215 11.8028 16.2009 11.6811 16.1643 11.5785C16.1262 11.4758 16.0631 11.3835 15.9751 11.3028C15.8857 11.2193 15.7699 11.1459 15.6276 11.0785C15.4854 11.011 15.3065 10.9421 15.0954 10.8718C14.8153 10.7779 14.5719 10.6738 14.3652 10.5624C14.1599 10.4524 13.9884 10.3219 13.8505 10.1709C13.7127 10.0213 13.6116 9.84831 13.547 9.65184C13.4825 9.45389 13.4503 9.22809 13.4503 8.96857C13.4503 8.34688 13.6233 7.88501 13.9693 7.58003C14.3139 7.27505 14.7904 7.12256 15.3945 7.12256C15.676 7.12256 15.9356 7.15335 16.1731 7.21493C16.4106 7.27651 16.6159 7.37475 16.7889 7.51405C16.9619 7.65187 17.0968 7.82782 17.1936 8.04043C17.2889 8.2545 17.3388 8.51109 17.3388 8.81021V8.98616H16.1247C16.1247 8.68705 16.0719 8.45684 15.9678 8.29409C15.8622 8.13427 15.6863 8.05216 15.44 8.05216C15.2992 8.05216 15.1819 8.07415 15.0881 8.11374C14.9957 8.1548 14.9194 8.20905 14.8637 8.2765C14.808 8.34394 14.7714 8.42165 14.7508 8.50963C14.7288 8.5976 14.72 8.68851 14.72 8.78235C14.72 8.97736 14.7611 9.13865 14.8432 9.27061C14.9253 9.40404 15.1013 9.52574 15.371 9.63571L16.3476 10.058C16.588 10.1636 16.7845 10.2735 16.9355 10.3894C17.088 10.5037 17.2112 10.6269 17.3006 10.7589ZM5.71873 10.3511L7.17912 7.24561H5.79791L4.99734 9.27783L4.18797 7.24561H2.78917L4.23196 10.3511L2.666 13.527H4.05601L4.95482 11.398L5.8595 13.527H7.28469L5.71873 10.3511ZM9.92396 12.4889V7.24561H8.65712V13.527H12.1658V12.4889H9.92396Z",
  fill: "white"
});

var SvgAcExportXls = function SvgAcExportXls(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAcExportXls, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ac-export-xls.12523656.svg";
export { ForwardRef as ReactComponent };